import { render, staticRenderFns } from "./ProdGrid.vue?vue&type=template&id=31e6e33d&scoped=true&lang=pug&"
import script from "./ProdGrid.vue?vue&type=script&lang=js&"
export * from "./ProdGrid.vue?vue&type=script&lang=js&"
import style0 from "./ProdGrid.vue?vue&type=style&index=0&id=31e6e33d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../home/httpd/vhosts/tocin.com.tw/httpdocs/tocin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e6e33d",
  null
  
)

export default component.exports